import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-precision.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";

/*
 * @Author: your name
 * @Date: 2021-05-18 10:11:50
 * @LastEditTime: 2021-08-17 16:08:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \op-webe:\ubq-file\ubq-h5\src\filters\filter.js
 */
import moment from 'moment';
import 'moment/locale/zh-cn';
import ENUM from '@/utils/enum';
import Utils from '@/utils/utils';
moment.locale('zh-cn'); // // 金额转换
// export function formatMoneyUnit(num) {
//   if (num > 1000000) {
//     num = JSON.stringify(num).slice(0, JSON.stringify(num).length - 4) / 100
//     const intVal = JSON.stringify(num).slice(0, JSON.stringify(num).indexOf('.'))
//     const decVal =
//       JSON.stringify(num).substr(JSON.stringify(num).indexOf('.') + 1, 1) >= 2
//         ? '.' + JSON.stringify(num).substr(JSON.stringify(num).indexOf('.') + 1, 1)
//         : ''
//     return intVal + decVal + '万'
//   } else {
//     num = Math.round(num / 100)
//     return num + '元'
//   }
// }
// 格式化商品规格

export function skuFormat(val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '，';
  return val.replace(/[;]/gi, format);
} // 格式化时间

export function timeFormat(val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  if (!val && val !== 0) return '';else return moment(val).format(format);
} // 隐藏用户手机号中间四位

export function hidePhone(phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
} // 获取图片地址

export function imgUrl(val) {
  if (!val) return ''; // 兼容老数据

  return Utils.getFile(val, 'img.png');
} // 转百分比

export function percent(val) {
  if (!val && val !== 0) {
    return '';
  } // 防止精度丢失


  return parseFloat((val * 100).toPrecision(12)) + '%';
} // 转防止精度丢失

export function pricePercent(val) {
  if (!val && val !== 0) {
    return '';
  } // 防止精度丢失


  return parseFloat(Number(val).toPrecision(12)) + '';
} // 数值转价格

export function formatPrice(val) {
  if (!val && val !== 0) {
    return '';
  }

  var unit = val < 0 ? '-¥' : '¥';
  if (val < 0) val = Math.abs(val);
  val = (Math.round(val * 100) / 100).toFixed(2);
  return "".concat(unit).concat(val);
}
var regNum = /[.]/;
export function formatPriceHtml(val) {
  if (!val && val !== 0) {
    return '';
  }

  var res = val;

  if (regNum.test(res)) {
    res = res.toFixed(2);
  } else {
    res = "".concat(val);
  }

  var num = res.split('.');
  return "<em class=\"unit\">&yen;</em>\n    <em class=\"int\">".concat(num[0], "</em>\n    <em class=\"dec\">").concat(num[1] ? ".".concat(num[1]) : '', "</em>");
} // 处理浮点计算精度丢失问题

export function formatFloat(val, digit) {
  var num = Math.pow(10, digit);
  return Math.round(val * num, 10) / num;
}
export function formatBalance(val) {
  val = +val / 100;

  if (val > 0) {
    return regNum.test(val) ? val.toFixed(2) : val;
  } else return 0;
} // 两位数补零

export function zeroFill(num) {
  num = Number(num);
  return num < 10 ? '0' + num : num;
} // 隐藏名称的中间

export function stringBrief(val) {
  if (!val) return '';

  if (val.length < 16) {
    return val;
  }

  return val.slice(0, 6) + '...' + val.slice(-6);
} // 格式化时间

export function MDTimeFormat(val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD HH:mm:ss';
  if (!val && val !== 0) return '';else return moment(val).format(format);
} // 格式化时间

export function MsTimeFormat(val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD HH:mm';
  if (!val && val !== 0) return '';else return moment(val).format(format);
} // 格式化时间

export function bidTimeFormat(val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY.MM.DD';
  if (!val && val !== 0) return '';else return moment(val).format(format);
} // 获取权益兑换状态

export function rightExchangeStatus(val) {
  // const item = ENUM.rightExchangeStatusEnum.find(item => {
  //   return item.value === val
  // })
  // return item ? item.text : '未知'
  var item = ENUM.rightExchangeStatusEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取片段状态

export function fragmentStatus(val) {
  var item = ENUM.productStatus.find(function (item) {
    return item.value === val;
  });
  return item.text || '未知';
} // 获取品牌管状态

export function brandStatus(val) {
  var item = ENUM.brandsStatus.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取账单状态

export function transactionType(val) {
  var item = ENUM.dealType.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取充值状态

export function rechargeStatus(val) {
  var item = ENUM.rechargeStatusEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取提现状态

export function withdrawAuditStatus(val) {
  var item = ENUM.withdrawAuditStatusEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取优惠券类型

export function couponType(val) {
  var item = ENUM.couponTypeEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取众筹活动类型

export function crowdfundingType(val) {
  var item = ENUM.crowdfundingEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
} // 获取众筹活动状态

export function activityStatus(val) {
  var item = ENUM.activityEnum.find(function (item) {
    return item.value === val;
  }) || {};
  return item.text || '未知';
}